import type { App } from 'vue'
import Lenis from 'lenis'
import 'lenis/dist/lenis.css'

/**
 * Lenis 平滑捲動。
 *
 * 由 registerPlugins 自動載入（src/plugins/*.ts 的 default export）。
 * 預設接管整個視窗的捲動，並提供慣性、緩動效果。
 *
 * 若某個區塊不想被平滑捲動接管（例如自訂的內部捲動容器、彈窗），
 * 在該元素加上屬性 `data-lenis-prevent` 即可。
 *
 * Vuetify 下拉選單／彈窗等 overlay 透過 `prevent` 排除，保留原生滾輪捲動。
 */
function shouldPreventLenisScroll(node: Element): boolean {
  if (!(node instanceof HTMLElement))
    return false

  return !!(
    node.closest('.v-overlay__content')
    || node.closest('.v-menu')
    || node.closest('[role="listbox"]')
    || node.closest('[role="menu"]')
    || node.closest('[role="dialog"]')
  )
}

export default function (_app: App) {
  const lenis = new Lenis({
    duration: 1.1,
    easing: (t: number) => Math.min(1, 1.001 - 2 ** (-10 * t)),
    smoothWheel: true,
    prevent: shouldPreventLenisScroll,
  })

  // 對外提供實例，方便其他地方做 scrollTo 等操作
  ;(window as any).$lenis = lenis

  let rafId = 0
  const raf = (time: number) => {
    lenis.raf(time)
    rafId = requestAnimationFrame(raf)
  }

  rafId = requestAnimationFrame(raf)

  window.addEventListener('beforeunload', () => {
    cancelAnimationFrame(rafId)
    lenis.destroy()
  })
}
